import React from 'react';
import ViewVehicleModelComponent from '../../../Components/VehicleModel/ViewVehicleModel';

export default function ViewVehicleModel() {
    return (
        <div className='page-body'>
            <ViewVehicleModelComponent />
        </div>
    );
}